export const SidebarTabType = Object.freeze({
  GENERAL: 0,
  INPUT: 1,
  OUTPUT: 2,
})
